import { cn, Icon, type TableColumn, Typography } from "@kyan/ui";

import { tooltips } from "#/config/tooltips";
import { formatInstrumentName } from "#/utils/instrument.utils";

import { type RfqEntry } from "../../../../Rfq.types";

export const outerColumns: TableColumn<RfqEntry>[] = [
  {
    id: "instrument",
    header: "Instrument",
    minWidth: "220px",
    cellClassName: "pl-10",
    columnClassName: "pl-10",
    cell: (row, { isRowOpen }) => {
      const isSingleInstrumentCategory = row.variant === "single";
      const isPopulated = (row.count ?? 0) > 0;

      return (
        <div
          className={cn("flex w-full items-center gap-2 font-medium", {
            "text-textSecondary": !isPopulated,
          })}
        >
          <div className="dark:text-textPrimary text-textSecondary bg-textSecondary/10 grid size-4 place-items-center rounded-xs dark:bg-[linear-gradient(180deg,rgba(255,255,255,0.30)_3.48%,rgba(153,153,153,0.30)_97.87%)]">
            {isSingleInstrumentCategory ? "1" : "1+"}
          </div>
          <Typography>{formatInstrumentName(row.instrument)}</Typography>
          <Icon
            name="caret-up"
            className={cn(
              "text-xxs mr-2 ml-auto rotate-90 transition-transform",
              {
                "rotate-180": isRowOpen,
                "text-textSecondary": !isRowOpen,
              },
            )}
          />
        </div>
      );
    },
  },
  {
    id: "side",
    header: "Side",
    maxWidth: "70px",
    tooltip: tooltips.side,
  },
  {
    id: "price",
    header: "Price",
    maxWidth: "80px",
    tooltip: tooltips.price,
  },
  {
    id: "size",
    header: "Size",
    maxWidth: "50px",
    tooltip: tooltips.size,
  },
  {
    id: "imr",
    header: "IMr",
    minWidth: "130px",
    tooltip: tooltips.imr,
  },
  {
    id: "mmr",
    header: "MMr",
    minWidth: "130px",
    tooltip: tooltips.mmr,
  },
  {
    id: "delta",
    header: "Δ Delta",
    minWidth: "110px",
    tooltip: tooltips.delta,
  },
  {
    id: "gamma",
    header: "Γ Gamma",
    minWidth: "140px",
    tooltip: tooltips.gamma,
  },
  {
    id: "vega",
    header: "V Vega",
    minWidth: "110px",
    tooltip: tooltips.vega,
  },
  {
    id: "theta",
    header: "Θ Theta",
    minWidth: "130px",
    tooltip: tooltips.theta,
  },
  {
    id: "netPrice",
    header: "Net Price",
    minWidth: "130px",
    tooltip: tooltips.netPrice,
  },
  {
    id: "action",
    header: "Action",
  },
];
